import { useEffect } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import { observer } from 'mobx-react-lite'
import { useGuestStore } from '@/stores'
import { Button } from '@/components/ui/button'
import { Card, CardContent } from '@/components/ui/card'
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table'
import { User } from 'lucide-react'
import { Identicon } from '@/components/Identicon'

const GuestList = observer(() => {
  const { tenantId } = useParams<{ tenantId: string }>()
  const navigate = useNavigate()
  const guestStore = useGuestStore()

  useEffect(() => {
    if (tenantId) {
      guestStore.getGuests(tenantId)
    }
  }, [tenantId, guestStore])

  const handleViewDetails = (guestId: string) => {
    navigate(`/tenants/${tenantId}/guests/${guestId}`)
  }

  return (
    <>
      <div className="space-y-6 mb-6">
        <h1 className="text-3xl font-bold">ゲスト管理</h1>
      </div>
      <Card>
        <CardContent>
          {guestStore.guestsArray.length === 0 ? (
            <div className="text-center py-12 text-muted-foreground">
              <User className="h-12 w-12 mx-auto mb-4 opacity-50" />
              <p>ゲストがいません</p>
            </div>
          ) : (
            <Table>
              <TableHeader>
                <TableRow>
                  <TableHead className="w-12"></TableHead>
                  <TableHead>名前</TableHead>
                  <TableHead>LINE UID</TableHead>
                  <TableHead>ステータス</TableHead>
                  <TableHead>登録日時</TableHead>
                  <TableHead>更新日時</TableHead>
                  <TableHead className="text-right">操作</TableHead>
                </TableRow>
              </TableHeader>
              <TableBody>
                {guestStore.guestsArray.map((guest) => (
                  <TableRow key={guest.id}>
                    <TableCell>
                      {guest.avatar ? (
                        <img 
                          src={guest.avatar} 
                          alt={guest.name}
                          className="w-8 h-8 rounded-full object-cover"
                        />
                      ) : (
                        <Identicon source={guest.id} size={32} />
                      )}
                    </TableCell>
                    <TableCell className="font-medium">
                      {guest.name}
                    </TableCell>
                    <TableCell>
                      {guest.line_uid || '-'}
                    </TableCell>
                    <TableCell>
                      {guest.status_message || '-'}
                    </TableCell>
                    <TableCell>
                      {guest.created ? new Date(guest.created).toLocaleString('ja-JP') : '-'}
                    </TableCell>
                    <TableCell>
                      {guest.updated ? new Date(guest.updated).toLocaleString('ja-JP') : '-'}
                    </TableCell>
                    <TableCell className="text-right">
                      <Button
                        variant="outline"
                        size="sm"
                        onClick={() => handleViewDetails(guest.id)}
                      >
                        詳細
                      </Button>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          )}
        </CardContent>
      </Card>
    </>
  )
})

export default GuestList